import { MdDelete } from "react-icons/md";
import { CiStar } from "react-icons/ci";

const Product = ({
  _id,
  title,
  description,
  thumbnail,
  price,
  discountPercentage,
  rating,
  handleClick,
  handleBuy,
}) => {
  return (
    <div className="w-full md:w-1/4 p-4">
      <div className="flex flex-wrap bg-white border-none rounded-lg shadow-lg content-between h-full w-full ">
        <div className="w-full">
          <div className="flex relative justify-center">
            <div className="absolute left-0 top-0 bg-red-500 text-white p-1 rounded text-sm m-3">
              -{discountPercentage}%
            </div>
            <div className="absolute top-0 right-0 m-3 p-2 bg-white shadow-lg rounded-lg">
              <MdDelete
                onClick={() => handleClick(_id)}
                className="cursor-pointer text-red-500 text-xl"
              />
            </div>
          </div>
          <div className="flex flex-wrap items-center justify-center h-full w-full my-2">
            <img
              src={thumbnail}
              className="rounded-lg object-contain w-52 "
              alt={title}
            />
          </div>
        </div>
        <div className="flex flex-col p-4 justify-evenly w-full">
          <h5 className="font-bold text-lg">{title}</h5>
          <p className="text-sm my-2">{description}</p>
          <div className="flex justify-between mt-2">
            <div className="flex flex-col ">
              <span className="text-red-500 font-bold">
                $ {(price - (discountPercentage * price) / 100).toFixed(2)}
              </span>
              <small className="text-gray-500 line-through">
                $ {price.toFixed(2)}
              </small>
            </div>
            <div className="flex flex-end">
              {[...Array(rating)].map((_, index) => (
                <i key={index} className="fa fa-star text-yellow-400 mr-1" />
              ))}
              <span className="text-gray-500">
                <CiStar />
                {rating}
              </span>
            </div>
          </div>
          <div className="mt-4 text-center">
            <button
              className="text-purple-500 hover:text-purple-900 font-semibold cursor-pointer"
              onClick={handleBuy}
            >
              BUY +
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Product;
